module.exports = __webpack_public_path__ + "static/img/bg-pt.f4f2c4c0.png";